import { render, staticRenderFns } from "./SidebarBlock.vue?vue&type=template&id=1372f289&scoped=true"
import script from "./SidebarBlock.vue?vue&type=script&lang=ts"
export * from "./SidebarBlock.vue?vue&type=script&lang=ts"
import style0 from "./SidebarBlock.vue?vue&type=style&index=0&id=1372f289&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1372f289",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1372f289')) {
      api.createRecord('1372f289', component.options)
    } else {
      api.reload('1372f289', component.options)
    }
    module.hot.accept("./SidebarBlock.vue?vue&type=template&id=1372f289&scoped=true", function () {
      api.rerender('1372f289', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/browse/sidebar/SidebarBlock.vue"
export default component.exports